import React from 'react';

import SkuStore from '@/stores/sku';

export default function Sample(props: {
  price: PriceTypes.Root;
  sampleInfo: SampleTypes.Root;
  i18n: DetailTypes.i18n;
}) {
  const { sampleInfo, price, i18n } = props;
  if (!sampleInfo) return null;
  const skuInfo = SkuStore(state => state.product);
  const { isSoldOut } = skuInfo;
  return (
    <div className="price-sample">
      <div className="info">
        {i18n['detail_pc_sku_sample_floor_error_alarm_quantity']}
        {`${sampleInfo.maxQuantity} ${sampleInfo.maxQuantity > 1 ? price.unitEven : price.unit}`}
      </div>
      <div className="price">
        <span>
          {sampleInfo.formatPrice}
          {sampleInfo.formatOriginalPrice && <del>{sampleInfo.formatOriginalPrice}</del>}
        </span>
        <span className="other">/{price.unit}</span>
      </div>
      {isSoldOut && <div className="sold-out">{i18n['notice.content.wuhan']}</div>}
    </div>
  );
}
